<template>
  <div v-if="getloadedMenu" class="mobile-wrapper mb-4 pb-4">
    <div class="fixed-banner">
      <div class="container-fluid banner-alt">
        <div class="row">
          <div class="col-6 banner-title">
            <span class="material-icons md-36" @click="goOrder">keyboard_arrow_left</span>
            <span :class="isSushi ?  ' title-text-sushi montserrat-700' : 'title-text' " @click="goOrder">
              {{
              $t("message.yourOrder")
              }}
            </span>
          </div>
          <div class="btn col-6 text-right">
            <a @click="clearAllOrders()" :style="mobileStyles.LinkColorTxt" :class="isSushi &&  'montserrat-500'">
              {{
              $t("message.clearAll")
              }}
            </a>
          </div>
        </div>
      </div>
    </div>
    <!-- fixed-banner-double -->
    <div class="content-padding" />

    <div class="container mt-2">
      <div class="row cart-items" v-if="wholeOrderDiscount && wholeOrderDiscountMessage">
        <div
          :style="mobileStyles.successMsg"
          class="discount-container"
        >{{ wholeOrderDiscountMessage }}</div>
      </div>
    </div>
    <div class="container-fluid">
      <TransitionGroup v-if="showSharedCart" name="list">
        <div v-for="(name, index) in getPeople" :key="index">
          <b style="font-size: larger; color: blue;">{{ name }}'s Order </b>
          <div v-for="(item, idx) in getSharedCart[name].products" :key="idx">
            <cart-item :cart-item="item" :isSushi="isSushi" :removeButton="name === getUser"/>
          </div>
        </div>
      </TransitionGroup>
      <template v-else v-for="(item, index) in cartItems">
        <cart-item :cart-item="item" :key="index" :isSushi="isSushi" />
      </template>
    </div>

    <div class="col-sm-12" v-if="canshowRedemption">
      <div
        @click="addReedemption()"
        class="btn redeem-btn mb-2"
      >{{ $t("message.redeemStamps") }}: {{ canshowRedemption.Name }}</div>
    </div>
    <!-- /cart items -->
    <footer class="cart-footer">
      <div class="container-fluid">
        <div class="row mcart-totals" v-show="cartItems.length > 0 && cartValue > 0">
          <CouponComponent
            ref="couponComponent"
            :qrcode="qrcode"
            :ForMobile="true"
            :className="'mcart-totals'"
            :isSushi="isSushi"
          ></CouponComponent>
        </div>
        <div class="row mcart-totals">
          <div class="col-6"  :class="isSushi && 'montserrat-500'">{{ $t("message.subtotal") }} {{$t("message.exclude", { taxLabel })}}</div>
          <div class="col-6 mtotal-price" :class="isSushi && 'montserrat-500'">{{ subtotalPrice | formatMoney(currencySign) }}</div>
        </div>
        <div class="row mcart-totals">
          <div class="col-6" :class="isSushi && 'montserrat-500'">{{ taxLabel }}</div>
          <div class="col-6 mtotal-price" :class="isSushi && 'montserrat-500'">{{ totalGst | formatMoney(currencySign) }}</div>
        </div>
        <div v-if="showDelivery" class="row mcart-totals">
          <div class="col-6" :class="isSushi && 'montserrat-500'">{{ $t("message.delivery") }}</div>
          <div class="col-6 mtotal-price" :class="isSushi && 'montserrat-500'">{{ deliveryFee | formatMoney(currencySign) }}</div>
        </div>
        <div class="row mcart-totals">
          <div class="col-6" :class="isSushi && 'montserrat-500'">{{ $t("message.discount") }}</div>
          <div class="col-6 mtotal-price" :class="isSushi && 'montserrat-500'">{{ discount | formatMoney(currencySign) }}</div>
        </div>
        <div v-if="!hideSurcharge" class="row mcart-totals">
          <div class="col-6" :class="isSushi && 'montserrat-500'">{{ surchargeLabel }}</div>
          <div class="col-6 mtotal-price" :class="isSushi && 'montserrat-500'">{{ getSurchargeAmount(!isFromHomePage) | formatMoney(currencySign) }}</div>
        </div>

        <div class="row mcart-total">
          <div :class="[getPoints ? 'col-6' : 'col-8', isSushi && 'montserrat-500']">{{ totalLabel }}</div>
          <div v-if="getPoints" class="row" style="position: absolute; right: 15px;">
            <div :class="isSushi && 'montserrat-700'">{{ totalPrice - (deliveryFee) | formatMoney(currencySign) }}</div>
            <div
              class="text-success points"
              v-if="storeSupportsLoyaltyPoints"
            >({{ getPoints | formatNumber }} pts)</div>
          </div>
          <div v-else class="col-4 mtotal-price" :class="isSushi && 'montserrat-700'">{{ totalPrice - (deliveryFee) | formatMoney(currencySign) }}</div>
        </div>
        <div v-if="!exceedMinPurchase && !storeClosed" class="p-2 text-danger text-center">
          {{ $t("message.minimumPurchaseIs") }}
          {{ minPurchase | formatMoney(currencySign) }} ({{
          $t("message.excludingDeliveryFee")
          }})
        </div>
        <div
          v-show="
            storeClosed && store.ClosingStoreMessage
          "
          class="p-2 text-danger text-center"
          v-html="store.ClosingStoreMessage"
        />
        <div
          v-show="
            storeClosed && !store.ClosingStoreMessage
          "
          class="p-2 text-danger text-center"
        >{{ $t("message.CurrentlyNotTakingOnlineOrders") }}</div>
      </div>
      <div class="extras-footer">
        <router-link
          :to="{
            name: 'store',
            params: {
              storeid: $route.params.storeid,
              storename: $route.params.storename
            }
          }"
          class="btn "
          :class="isSushi ? 'montserrat-500 background-sushi-cancel text-white' : 'btn-cancel'"
          :style="isSushi ? mobileStyles.sushiBtn : mobileStyles.btn"
        >{{ $t("message.cancel") }}</router-link>
        <button
          @click="checkoutButtonClicked()"
          :disabled="cartItems.length === 0 || orderDisbaled || storeClosed === true"
          :class="{ disabled: orderDisbaled ? 'disabled' : '', 'background-sushi curved-10' :  isSushi }"
          class="btn btn-primary"
          :style="mobileStyles.btn"
          style="opacity:.8"
        >
          {{
          storeClosed
          ? $t("message.storeClosed")
          : IsSaveOrder
          ? $t("message.placeOrder")
          : $t("message.checkout")
          }}
        </button>
      </div>
      <poweredby v-if="!isBranded()" />
    </footer>

    <modal ref="redemptionModal" v-if="showRedemption" full-header @close="closeModal" hide-footer>
      <template slot="body">
        <div style="height: calc(100vh - 150px); overflow-y: auto; margin-bottom: 50px;">
          <Modifiers
            @canceled="closeModal"
            :product="selectedReedemption.product"
            :modifiers="selectedReedemption.modifiers"
            :product-id="selectedReedemption.productId"
            :price-trigger="canshowRedemption"
            @updated="selectRollIntoModiefiers"
            :is-submodifier="true"
            :has-confirm-button="true"
          />
        </div>
      </template>
    </modal>
    <modal v-if="ShowRorderMessage" ref="Reordermodal" full-header @close="closeReorderModal">
        <template slot="body">
        <div class="container">
          <div class="d-flex justify-content-center">
            <h2 class="p-2 mt-2 privacy-header" :class="isSushi && 'montserrat-500'">{{ $t("message.reorder") }}</h2>
          </div>
          <p class="py-4" :class="isSushi && 'montserrat-500'">{{ $t('message.ReorderMessage') }}</p>
        </div>
      </template>
      <template slot="footer" class="bg-body">
        <div class="w-100" style="z-index: 2;">
          <button
            class="privacy-btn pull-right"
            data-dismiss="modal"
            type="button"
            :style="buttonStyles"
            @click="closeReorderModal()"
          >{{ $t("message.ok") }}</button>
        </div>
        <div class="privacy-footer" />
      </template>
    </modal>
    <cross-cell :showCrossCell="showCrossCell" v-if="!storeSelectionAtCheckoutMode" :isSushi="isSushi"></cross-cell>
  </div>
  <progressindicator v-else style="opacity:0.4"></progressindicator>
</template>
<script>
import CartItem from "./CartItemMobile";
import poweredby from "../../shared/poweredby";
import CouponComponent from "./CouponComponent";
import modal from "../../modal";
import shared from "../../../sharedscripts/shop/shopping-cart/ShoppingCart.js";
import Modifiers from "../products/Modifiers.vue";
import Progressindicator from "../../progressindicator";
import uuid from "uuid/v1";
import { getOrderHistory } from "../../../api/services/orderService.js";
import { mapGetters } from "vuex";
import CrossCell from './CrossCellMobile.vue';
export default {
  name: "ShoppingCart",
  components: {
    CartItem,
    poweredby,
    CouponComponent,
    modal,
    Modifiers,
    Progressindicator,
    CrossCell
  },
  props: {
    orderType: {
      type: Number,
      default: 3
    },
    qrcode: {
      type: String,
      default: ""
    },
    orderid: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      showCrossCell: false,
      showAddToCartModal: true,
      productToShow: null,
      selectedCategory: null,
      store: {},
      storeClosed: false,
      timerId: null,
      minPurchase: 0,
      dpTimeIsSet: true,
      IsInOperationMessage: null,
      selectedReedemption: null,
      showRedemption: false,
      IsSaveOrder: false,
      ShowRorderMessage: false
    };
  },
  created() {
    this.store = this.selectedCompany;
    this.checkStoreClosed();
  },
  computed: {
    ...mapGetters([
      "getPapularProducts",
      "hqDoc",
      "getCrossCellViewed",
      "getSharedCart",
      "showSharedCart",
      "getSharedCartProps",
      "currentStoreDoc",
      "getUser",
      "getPeople",
      "totalGst",
    ]),
    ...shared.computed,
    popularProductsExcludeCartItems() {
      const popluartProducts = [];
      this.getPapularProducts.forEach(p => {
        if(!this.cartItems.find(c => c.id === p.ProductID)) {
          popluartProducts.push(p);
        }
      });
      return popluartProducts
    },
    getCategory() {
      let parentCategory;
      this.menu.Categories.forEach(c => {
        if(c.SubMenuItems.find(p => p.ProductID === this.productToShow.ProductID)) {
            parentCategory = JSON.parse(JSON.stringify(c));
        }
      })
      return parentCategory
    },
    menu: function() {
      return JSON.parse(JSON.stringify(this.storeMenu))
    },
    surchargeLabel() {
      const showPercentage = this.selectedCompany.ViewComponentConfigs.ShowSurchargePercentage
        && this.getSurchargePercentage();

      return showPercentage
        ? this.$t("message.surcharge").concat(
          ' (',
          this.getSurchargePercentage(),
          '%)'
        ) : this.$t("message.surcharge");
    },

    isSushi(){
      return this.hqDoc && this.hqDoc.IsSushiHub
    }
  },
  watch: {
    selectedCompany(newValue) {
      this.store = newValue;
      this.checkStoreClosed();
    },
    orderType(newValue) {
      this.computeRules(newValue);
    },
    totalPrice() {
      this.computeRules(this.orderMode);
    },
    cartItems: {
      handler: function(newValue) {
        this.fixRedemptionQuantity(newValue);
      },
      deep: true
    }
  },
  mounted() {
    this.setShowDeliveryFee(true);
    if (sessionStorage.getItem("paymenttype") == "saveorder")
      this.IsSaveOrder = true;
    if (this.orderid) {
        var that = this;
        let odata = localStorage.getItem(this.store.ID + "-OrdersDatas");
        let OrdersData = odata != null ? JSON.parse(odata) : [];

        let savedorder = OrdersData.find(function(x) {
          return x.UDID == that.orderid;
        });
        if (savedorder) {
          that.clearAllOrders();
          that.SetOrder(savedorder, that);
          that.updateShoppingCartItems();
          if(savedorder.OrderItems.length > that.cartItems.length)
                  that.ShowRorderMessage = true;
        } else {
          getOrderHistory(that.user.id, that.orderid)
            .get()
            .then(async (result) => {
              if (result.exists) {
                result = result.data();
                that.clearAllOrders();
                await that.SetOrder(result, that);
                that.updateShoppingCartItems();
                that.computeRules();
                if (
                  result.OrderItems.length > that.cartItems.length
                ) {
                  that.ShowRorderMessage = true;
                }
              }
            });
        }
      }
  },
  beforeDestroy() {
    if (this.timerId) {
      clearInterval(this.timerId);
    }
  },
  methods: {
    ...shared.methods,
    checkoutButtonClicked() {
      // if(!this.getCrossCellViewed) {
      //   console.log("failed to checkout")
      //   this.showCrossCell = true;
      // } else {
      //   console.log("checking out")
        this.navigateToCheckout();
      // }
    },
    closeModal() {
      this.showAddToCartModal = false;
      this.productToShow = null;
    },
    clearAllOrders() {
      this.cartItems.forEach((cartitem) => {
        this.REMOVE_CART_ITEM({
          item: cartitem,
          sharedcart: this.showSharedCart,
          user: this.getSharedCartProps.user,
          table: this.getSharedCartProps.table,
          storeId: this.currentStoreDoc.ID
        });
        this.applyPriceTriggers();
      });
    },
    closeReorderModal() {
      this.$refs.Reordermodal.hideModal();
      this.ShowRorderMessage = false;
    },
    SetOrder(order, ins) {
      var that = ins;
      order.OrderItems.forEach((orderitem) => {
        var product = that.getProductOutcomeInfo(orderitem.Product_ID);
        if (product && product.Status != 3) {
          var modifiers = orderitem.OrderExtras.map((m) => {
            var result = {
              quantity: m.Quantity,
              TaxRate: m.UsingUnitPrice > 0 ? m.FinalTax / m.UsingUnitPrice : 0,
              Price: m.UsingUnitPrice,
              ID: m.Extra_ID,
              Name: m.Name,
            };
            if (m.ChildrenOrderExtras)
              result.selectedSubmodifiers = m.ChildrenOrderExtras.map((m2) => {
                return {
                  quantity: m2.Quantity,
                  TaxRate:
                    m2.UsingUnitPrice > 0 ? m2.FinalTax / m2.UsingUnitPrice : 0,
                  Price: m2.UsingUnitPrice,
                  ID: m2.Extra_ID,
                  Name: m2.Name,
                };
              });
            return result;
          });
          that.Add_ProductItem({
            item: {
              id: orderitem.Product_ID,
              uniqueId: uuid(),
              code: product.ProductCode,
              name: product.Name,
              description: product.ShortDescription,
              photoUrl: product.PhotoUrl,
              tax: product.TaxRate,
              price: orderitem.UsingUnitPrice,
              categoryId: orderitem.CategoryId,
              categoryName: orderitem.CategoryName,
            },
            ProductCategoryIDs: product.ProductCategoryIDs,
            ProductTagIDs: product.ProductTagIDs,
            quantity: orderitem.Quantity,
            PreparationTime: product.PreparationTime,
            modifiers: modifiers,
            sharedcart: this.showSharedCart,
            user: this.getSharedCartProps.user,
            table: this.getSharedCartProps.table,
            storeId: this.currentStoreDoc.ID
          });
        }
      });
      that.applyPriceTriggers();
    },
  }
};
</script>
